import { setDeleteEducationModal, setSelectedEducation } from '../../../../../store/workspace/slice';
import { updateProfileDataThunk } from '../../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../../store/store';
import { TrashSquareIcon } from '../../../../../assets/icons/common';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './styles.module.scss';
import { useEffect } from 'react';
import {
    selectProfileData,
    selectSelectedEducation,
    selectUpdatingProfileData,
} from '../../../../../store/workspace/selectors';

export default function DeleteEducation() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfileData);
    const isLoading = useSelector(selectUpdatingProfileData);
    const selectedEducation = useSelector(selectSelectedEducation);

    useEffect(() => {
        return () => {
            dispatch(setSelectedEducation(null));
        }
    }, []);

    const submit = () => {
        if (!profile) return;
        const { kyc, matchedJobs, setting, ...rest } = profile;
        const filteredList = profile.educationInfo.filter(i => i.id !== selectedEducation?.id);
        dispatch(updateProfileDataThunk({ ...rest, educationInfo: [...filteredList] }));
    };

    return (
        <Modal
            size='sm'
            title='Delete degree'
            icon={<TrashSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setDeleteEducationModal(false))}
        >
            <h3>Are you sure you want to delete "{selectedEducation?.universityName}" ?</h3>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setDeleteEducationModal(false))}
                />
                <Button
                    type='Error'
                    text='Delete'
                    onClick={submit}
                    loading={isLoading}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
